export const toQueryString = (
  obj?: Record<string, string | number | undefined>,
) =>
  obj && Object.keys(obj).filter(([_key, value]) => Boolean(value)).length > 0
    ? `${Object.entries(obj)
        .filter(([_key, value]) => Boolean(value))
        .map(
          ([key, value]) =>
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            `${encodeURIComponent(key)}=${encodeURIComponent(value!)}`,
        )
        .join('&')}`
    : '';
